import "./WordDisplayBox.css";
import { Box } from "@mui/material";

const WordDisplayBox = ({ text, fontSize }) => {
  if (!text) return null;

  const words = text.split(",");
  return (
    <Box className="word-display">
      {words.map((word, index) => (
        <Box
          className="word-box-display-container"
          key={index}
          sx={{
            fontSize: `${fontSize}vw`,
          }}
        >
          {word.trim()}
        </Box>
      ))}
    </Box>
  );
};

export default WordDisplayBox;
